import {
  CommodityComplexFilterInput,
  CommodityFilterByTerm,
  CommodityStatusCode,
  FilterOperator,
  PersonaType,
} from '@bechtel/types';
import { useEffect } from 'react';
import { useCommodityFitupStatsQuery } from '../use-commodity-fitup-stats';

export function useCommodityFitupStatsFWEQueryResult(weldTypeId, crewMember, weldFilter, skip?: boolean) {
  const [
    getCommodityFitupStats,
    { error: fitupStatsError, data: fitupStatsData, loading: fitupLoading, refetch: fitUpRefetch },
  ] = useCommodityFitupStatsQuery(true);
  useEffect(() => {
    if (
      skip ||
      !crewMember?.persona ||
      !crewMember?.id ||
      !weldTypeId ||
      crewMember?.persona === PersonaType.SUPER_ADMIN
    )
      return;
    const complexFilterInput: CommodityComplexFilterInput = {
      and: [
        {
          term: CommodityFilterByTerm.PRIMARY_CREW_MEMBER_ID,
          value: crewMember.id,
          operator: FilterOperator.EQUALS,
        },
        {
          term: CommodityFilterByTerm.COMMODITY_TYPE_ID,
          value: weldTypeId,
          operator: FilterOperator.EQUALS,
        },
        {
          term: CommodityFilterByTerm.APPLY_ASSOCIATED_CREW_MEMBERS,
          value: 'true',
          operator: FilterOperator.EQUALS,
        },
        {
          term: CommodityFilterByTerm.PERSONA_TYPE_ID,
          value: crewMember?.persona,
          operator: FilterOperator.EQUALS,
        },
        {
          term: CommodityFilterByTerm.COMMODITY_STATUS_ID,
          value: CommodityStatusCode.FITUP_INSPECTION,
          operator: FilterOperator.EQUALS,
        },
        {
          term: CommodityFilterByTerm.INCLUDE_BLOCKED_COMMODITY,
          value: 'true',
          operator: FilterOperator.EQUALS,
        },
      ],
    };
    // Add CREW_MEMBER_ID filter if foremen are selected from dropdown
    if (weldFilter?.searchByForeman?.length > 0) {
      complexFilterInput.and?.push({
        term: CommodityFilterByTerm.CREW_MEMBER_ID,
        values: [...weldFilter.searchByForeman],
        operator: FilterOperator.IN,
      });
    }

    getCommodityFitupStats({
      variables: {
        input: {
          complexFilter: complexFilterInput,
        },
      },
    });
  }, [crewMember?.persona, crewMember?.id, getCommodityFitupStats, weldTypeId, weldFilter, skip]);

  return {
    fitupStatsError,
    fitupStatsData,
    fitupLoading,
    fitUpRefetch,
  };
}
